import React from "react";
import SecondaryCheckbox from "Components/common/SecondaryCheckbox";
import { ReactComponent as SequenceIcon } from "Assets/svg/sequence.svg";

const ExternalLinkIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.987567 9.56269C0.363919 7.22737 0.968147 4.63236 2.80025 2.80025C5.53392 0.0665824 9.96608 0.0665827 12.6997 2.80025C15.4334 5.53392 15.4334 9.96608 12.6997 12.6997C10.8676 14.5319 8.27263 15.1361 5.93731 14.5124M9.8501 9.85007V5.65007M9.8501 5.65007H5.6501M9.8501 5.65007L2.84997 12.65"
      stroke="#3953FB"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ConnectedInboxSequenceCard = (props = {}) => {
  const {
    id = "",
    label = "",
    totalSequences = 0,
    activeSequences = 0,
    cbk = () => { },
    checked = false,
    onActionIconClick = () => { }
  } = props || {};

  const handleCheckboxChange = (val) => {
    cbk(val, id, label);
  };

  const handleActionIconClick = (e) => {
    e.stopPropagation();
    onActionIconClick(id, label);
  };

  const inputObj = {
    label: "",
    id: `inbox-card-${id}`,
    cbk: handleCheckboxChange,
    checked: checked
  };

  return (
    <div className="connectedInboxSequenceCard">
      <div className="cardMainContent">
        <div className="inboxInfo">
          <div className="inboxEmail">{label}</div>
          <div className="inboxStats">
            <span className="statsLabel">
              <SequenceIcon className="sequenceIcon" />
              Sequence:
            </span>
            <span className="statsBadge connectedBadgeGrey">{totalSequences} Connected</span>
            <span className="statsBadge activeBadge">{activeSequences} Active</span>
          </div>
        </div>
      </div>
      <div className="actionArea">
        <button
          type="button"
          className="inboxActionIcon"
          title="View inbox sequences"
          onClick={handleActionIconClick}
        >
          <ExternalLinkIcon />
        </button>
      </div>
    </div>
  );
};

export default ConnectedInboxSequenceCard;
